import { TranslationKey } from '../../../../types/translation/TranslationKey';
import React from 'react';
import { Container } from '../../../../types/container';
import { Product } from '../../../../types/product';
import { ProductMasterData } from '../../../../types/product_master_data/productMasterData';
import { t } from '../../../../types/translation/Translator';
import BoxIcon from '../../../../VentoryUI/icons/Box/BoxIcon';
import PackageIcon from '../../../../VentoryUI/icons/Package/PackagIcon';

export function ProductOrContainerNameColumn({
  productMasterDataId,
  containerId,
  productMasterData,
  containers,
}: {
  productMasterDataId: string | undefined | false;
  containerId: string | undefined | false;
  productMasterData: Map<string, ProductMasterData>;
  containers: Map<string, Container>;
}) {
  const name = _Name(productMasterDataId, containerId, productMasterData, containers);

  return (
    <div className='flex flex-nowrap items-center overflow-hidden'>
      <div className='pr-2'>{_Icon(productMasterDataId, containerId)}</div>

      <span className='overflow-hidden text-ellipsis text-nowrap' title={name}>
        {name}
      </span>
    </div>
  );
}

function _Name(
  productMasterDataId: string | undefined | false,
  containerId: string | undefined | false,
  productMasterData: Map<string, ProductMasterData>,
  containers: Map<string, Container>,
) {
  if (productMasterDataId) {
    return (
      productMasterData.get(productMasterDataId)?.productName ??
      t(TranslationKey.unknownProductReference).singular.label
    );
  }

  if (containerId) {
    return containers.get(containerId)?.identifier || t(TranslationKey.unknownContainer).singular.label;
  }

  return '';
}

function _Icon(productMasterDataId: string | undefined | false, containerId: string | undefined | false) {
  if (productMasterDataId) {
    return <PackageIcon />;
  }

  if (containerId) {
    return <BoxIcon />;
  }

  return <></>;
}

export function ProductOrContainerContainerColumn(item: Product | Container, containers: Map<string, Container>) {
  if (item instanceof Product) {
    if (!item.containerId) return '';
    return containers.get(item.containerId)?.identifier || t(TranslationKey.unknownContainer).singular.label;
  }

  if (item instanceof Container) {
    if (!item.parentId) return '';
    return containers.get(item.parentId)?.identifier || t(TranslationKey.unknownContainer).singular.label;
  }

  return '';
}
